<script setup lang="ts">
import UIButton from '@/shared/ui/Button/index';
import { type Props } from './types';

const props = withDefaults(defineProps<Props>(), {
  title: '',
  description: '',
  images: () => ({
    desktop: '',
    mobile: '',
  }),
  buttonText: '',
  isHideLineBreak: false,
  to: '',
});

const emit = defineEmits(['click']);

const bannerDesktopImage = computed(() => `url(${props.images.desktop})`);
const bannerMobileImage = computed(() => `url(${props.images.mobile})`);

const clickHandler = (): void => {
  emit('click');
};
</script>

<template>
  <div :class="['banner', { _hide: isHideLineBreak }]">
    <div class="banner__content">
      <div class="banner__info">
        <div class="banner__title" v-html="title"></div>
        <div v-if="description" class="banner__subtitle" v-html="description"></div>
      </div>
      <div v-if="buttonText" class="banner__actions">
        <UIButton
          class="banner__button"
          :text="buttonText"
          white
          shadow
          :aria-label="buttonText"
          :to="to"
          @click="clickHandler"
        />
      </div>
    </div>
  </div>
</template>

<style lang="less">
.banner {
  width: 100%;
  height: 100%;

  &__content {
    .flex-column(@size-x8);

    background-image: v-bind(bannerDesktopImage);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: @size-x4;
    height: 100%;
    padding: 48px;
  }

  &__info {
    .flex-column(@size-x4);
  }

  &__title {
    font-size: @size-x9;
    line-height: 102%;
    font-weight: 600;
    color: @color-oxford-blue;
    word-wrap: break-word;
  }

  &__subtitle {
    font-size: @size-x5;
    line-height: 100%;
    font-weight: 400;
    color: @color-oxford-blue;
  }

  &__actions {
    display: inline-flex;
    gap: @size-x6;
  }

  &__button {
    max-width: 130px;
  }

  @media @1024 {
    &__content {
      background-image: v-bind(bannerMobileImage);
      gap: @size-x6;
      padding: @size-x6;
    }

    &__info {
      gap: @size-x2;
    }

    &__title {
      font-size: @size-x6;
    }

    &__subtitle {
      font-size: 14px;
    }

    &._hide &__title br {
      display: none;
    }

    &._hide &__subtitle br {
      display: none;
    }

    &__button {
      max-width: 111px;
      font-size: 13px;
      line-height: 100%;
    }
  }
}
</style>
